import React, { Fragment } from "react";

import { Helmet } from "react-helmet";

import NavigationBarGeneral from "../components/navigation-bar-general";
import FAQWorkWithUs from "../components/faq-work-with-us";
import ContactFormDark from "../components/contact-form-dark";
import Footer from "../components/footer";
import "./partner.css";

const Partner = (props) => {
  return (
    <div className="partner-container1">
      <Helmet>
        <title>
          Partner with CashOver Pay | Host an ATM or Become an Agent
        </title>
        <meta
          name="description"
          content="Partner with CashOver Pay to host ATMs or become an agent. Help Lebanese customers send, receive, and exchange LBP, USD, and USDT securely and conveniently."
        />
        <meta
          property="og:title"
          content="Partner with CashOver Pay | Host an ATM or Become an Agent"
        />
        <meta
          property="og:description"
          content="Partner with CashOver Pay to host ATMs or become an agent. Help Lebanese customers send, receive, and exchange LBP, USD, and USDT securely and conveniently."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/store.webp`}
        />
      </Helmet>
      <NavigationBarGeneral
        text={
          <Fragment>
            <span className="partner-text10">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="partner-text11">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-generalroot-class-name1"
      ></NavigationBarGeneral>
      <header className="partner-column10">
        <div className="partner-dummy"></div>
        <div className="partner-column11">
          <h1 className="partner-text12">Become a CashOver PARTNER Now!</h1>
          <div className="partner-row10">
            <svg viewBox="0 0 1024 1024" className="partner-icon10">
              <path d="M682.667 810.667c-34.219 0-66.347-13.312-90.539-37.504l-80.128-80.171-80.171 80.171c-48.341 48.341-132.651 48.341-181.035 0-24.149-24.149-37.461-56.32-37.461-90.496s13.312-66.347 37.504-90.539l80.128-80.128-80.128-80.171c-24.192-24.149-37.504-56.32-37.504-90.496s13.312-66.347 37.504-90.539c48.341-48.299 132.651-48.341 181.035 0.043l80.128 80.171 80.171-80.171c48.341-48.341 132.651-48.341 181.035 0 24.149 24.149 37.461 56.32 37.461 90.496s-13.312 66.347-37.504 90.539l-80.128 80.128 80.128 80.171c24.192 24.149 37.504 56.32 37.504 90.496s-13.312 66.347-37.504 90.539c-24.149 24.149-56.277 37.461-90.496 37.461zM512 572.331l140.501 140.501c16.128 16.128 44.245 16.085 60.331 0 8.064-8.064 12.501-18.731 12.501-30.165s-4.437-22.101-12.501-30.165l-140.459-140.501 140.459-140.501c8.064-8.064 12.501-18.773 12.501-30.165s-4.437-22.101-12.501-30.165c-16.128-16.171-44.245-16.128-60.331-0.043l-140.501 140.544-140.501-140.501c-16.128-16.128-44.245-16.085-60.331 0-8.064 8.064-12.501 18.773-12.501 30.165s4.437 22.101 12.501 30.165l140.459 140.501-140.459 140.501c-8.064 8.064-12.501 18.731-12.501 30.165s4.437 22.101 12.501 30.165c16.128 16.171 44.245 16.128 60.331 0.043l140.501-140.544z"></path>
            </svg>
            <h2 className="partner-text13">
              <span className="partner-text14">
                Or put a CashOver
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="partner-text15">ATM</span>
              <span className="partner-text16"> at Your Store</span>
            </h2>
            <svg viewBox="0 0 1024 1024" className="partner-icon12">
              <path d="M682.667 810.667c-34.219 0-66.347-13.312-90.539-37.504l-80.128-80.171-80.171 80.171c-48.341 48.341-132.651 48.341-181.035 0-24.149-24.149-37.461-56.32-37.461-90.496s13.312-66.347 37.504-90.539l80.128-80.128-80.128-80.171c-24.192-24.149-37.504-56.32-37.504-90.496s13.312-66.347 37.504-90.539c48.341-48.299 132.651-48.341 181.035 0.043l80.128 80.171 80.171-80.171c48.341-48.341 132.651-48.341 181.035 0 24.149 24.149 37.461 56.32 37.461 90.496s-13.312 66.347-37.504 90.539l-80.128 80.128 80.128 80.171c24.192 24.149 37.504 56.32 37.504 90.496s-13.312 66.347-37.504 90.539c-24.149 24.149-56.277 37.461-90.496 37.461zM512 572.331l140.501 140.501c16.128 16.128 44.245 16.085 60.331 0 8.064-8.064 12.501-18.731 12.501-30.165s-4.437-22.101-12.501-30.165l-140.459-140.501 140.459-140.501c8.064-8.064 12.501-18.773 12.501-30.165s-4.437-22.101-12.501-30.165c-16.128-16.171-44.245-16.128-60.331-0.043l-140.501 140.544-140.501-140.501c-16.128-16.128-44.245-16.085-60.331 0-8.064 8.064-12.501 18.773-12.501 30.165s4.437 22.101 12.501 30.165l140.459 140.501-140.459 140.501c-8.064 8.064-12.501 18.731-12.501 30.165s4.437 22.101 12.501 30.165c16.128 16.171 44.245 16.128 60.331 0.043l140.501-140.544z"></path>
            </svg>
          </div>
        </div>
        <div className="partner-row11">
          <svg viewBox="0 0 1024 1024" className="partner-icon14">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
          <span className="partner-text17">
            Scroll Down to Discover The Benefits
          </span>
          <svg viewBox="0 0 1024 1024" className="partner-icon16">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
        </div>
      </header>
      <main className="partner-column12">
        <h2 className="partner-text18">
          <span className="partner-text19">Choose what you need!</span>
          <br></br>
        </h2>
        <p className="partner-text21">
          <span>
            CashOver allows you to host an
            <span
              dangerouslySetInnerHTML={{
                __html: " ",
              }}
            />
          </span>
          <span className="partner-text23">ATM machine</span>
          <span> at your location.</span>
          <br></br>
          <span>
            You can become an exclusive
            <span
              dangerouslySetInnerHTML={{
                __html: " ",
              }}
            />
          </span>
          <span className="partner-text27">CashOver Agent.</span>
          <br></br>
        </p>
        <div className="partner-row12">
          <img alt="image" src="/store.webp" className="partner-image1" />
          <img alt="image" src="/credit_card.webp" className="partner-image2" />
        </div>
      </main>
      <main className="partner-column13">
        <img alt="image" src="/icon.webp" className="partner-image3" />
        <h2 className="partner-text29">
          <span>Discover the perks</span>
          <br></br>
        </h2>
        <p className="partner-text32">
          <span>
            Learn more about the benefits that you can get when working with us.
          </span>
          <br></br>
        </p>
      </main>
      <main className="partner-column14">
        <div className="partner-row13">
          <span className="partner-text35">01</span>
          <div className="partner-column15">
            <h2 className="partner-text36">ATM HOSTING</h2>
            <span className="partner-text37">Recommended</span>
          </div>
        </div>
        <div className="partner-row14">
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1592495981488-073153776d9a?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w5MTMyMXwwfDF8c2VhcmNofDgzfHxtb25leXxlbnwwfHx8fDE3MTUzODAwMzR8MA&amp;ixlib=rb-4.0.3&amp;q=80&amp;h=300"
            loading="eager"
            className="partner-image4"
          />
          <div className="partner-column16">
            <h3 className="partner-text38">Earn Income</h3>
            <p className="partner-text39">
              Process invoices at your store to earn commission depending on
              your popularity and processed volume.
            </p>
          </div>
        </div>
        <div className="partner-row15">
          <div className="partner-column17">
            <h3 className="partner-text40">Drive traffic</h3>
            <p className="partner-text41">
              Attract more customers when people notice your store is visited a
              lot!
            </p>
          </div>
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1515445182358-a8802afe3130?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDZ8fGJ1c3klMjBzdG9yZXxlbnwwfHx8fDE3MTYyNjA2MTJ8MA&amp;ixlib=rb-4.0.3&amp;w=1400"
            loading="eager"
            className="partner-image5"
          />
          <div className="partner-column18">
            <h3 className="partner-text42">Earn Income</h3>
            <p className="partner-text43">
              Process invoices at your store to earn commission depending on
              your popularity and processed volume.
            </p>
          </div>
        </div>
        <div className="partner-row16">
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1501526029524-a8ea952b15be?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDM5fHxncmFwaHxlbnwwfHx8fDE3MTYyNjA2OTZ8MA&amp;ixlib=rb-4.0.3&amp;w=1400"
            loading="eager"
            className="partner-image6"
          />
          <div className="partner-column19">
            <h3 className="partner-text44">Drive sales</h3>
            <p className="partner-text45">
              People withdrawing will buy from your stores when they have cash
              on them.
            </p>
          </div>
        </div>
        <div className="partner-row17">
          <div className="partner-column20">
            <h3 className="partner-text46">withdraw directly</h3>
            <p className="partner-text47">
              Withdraw your revenue from the ATM at your store directly.
            </p>
          </div>
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1580067319115-42124a255c57?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDIxfHxjYXNofGVufDB8fHx8MTcxNjI2MDcyMXww&amp;ixlib=rb-4.0.3&amp;w=1400"
            loading="eager"
            className="partner-image7"
          />
          <div className="partner-column21">
            <h3 className="partner-text48">Earn Income</h3>
            <p className="partner-text49">
              Process invoices at your store to earn commission depending on
              your popularity and processed volume.
            </p>
          </div>
        </div>
      </main>
      <main className="partner-column22">
        <div className="partner-row18">
          <span className="partner-text50">02</span>
          <h2 className="partner-text51">CASHOVER AGENT</h2>
        </div>
        <div className="partner-row19">
          <div className="partner-container2">
            <svg viewBox="0 0 1024 1024" className="partner-icon18">
              <path d="M504 466q44 12 73 24t61 33 49 53 17 76q0 62-41 101t-109 51v92h-128v-92q-66-14-109-56t-47-108h94q8 90 126 90 62 0 89-23t27-53q0-72-128-104-200-46-200-176 0-58 42-99t106-55v-92h128v94q66 16 101 60t37 102h-94q-4-90-108-90-52 0-83 22t-31 58q0 58 128 92z"></path>
            </svg>
            <h2 className="partner-text52">Earn Commisions</h2>
            <p className="partner-text53">
              Gain access to a steady stream of commissions and fees for every
              money transaction processed through your store, bolstering your
              bottom line.
            </p>
          </div>
          <div className="partner-container3">
            <svg viewBox="0 0 1024 1024" className="partner-icon20">
              <path d="M896 597.333h-256c-23.595 0-42.667-19.115-42.667-42.667s19.072-42.667 42.667-42.667h256c23.595 0 42.667 19.115 42.667 42.667s-19.072 42.667-42.667 42.667z"></path>
              <path d="M768 725.333c-23.595 0-42.667-19.115-42.667-42.667v-256c0-23.552 19.072-42.667 42.667-42.667s42.667 19.115 42.667 42.667v256c0 23.552-19.072 42.667-42.667 42.667z"></path>
              <path d="M384 256c70.571 0 128 57.429 128 128s-57.429 128-128 128-128-57.429-128-128 57.429-128 128-128M384 170.667c-117.931 0-213.333 95.488-213.333 213.333s95.403 213.333 213.333 213.333 213.333-95.488 213.333-213.333-95.403-213.333-213.333-213.333z"></path>
              <path d="M384 725.333c86.229 0 140.843 32.896 161.408 61.653-29.141 11.093-84.011 23.68-161.408 23.68-84.651 0-136.789-13.013-162.901-23.125 19.584-30.507 75.819-62.208 162.901-62.208M384 640c-160 0-256 85.333-256 170.667 0 42.667 96 85.333 256 85.333 150.101 0 256-42.667 256-85.333s-100.437-170.667-256-170.667z"></path>
            </svg>
            <h2 className="partner-text54">Drive More Traffic</h2>
            <p className="partner-text55">
              CashOver services attract a diverse customer base. This means
              increased foot traffic to your store, potentially leading to
              higher sales of your existing products and services.
            </p>
          </div>
        </div>
      </main>
      <FAQWorkWithUs rootClassName="faq-work-with-usroot-class-name"></FAQWorkWithUs>
      <ContactFormDark rootClassName="contact-form-darkroot-class-name"></ContactFormDark>
      <Footer rootClassName="footerroot-class-name2"></Footer>
    </div>
  );
};

export default Partner;
